import axios from 'axios';

const instance = () => {
  const authData = localStorage.getItem('auth');
  let apiUrl = 'http://localhost:9000/';
  switch (window.location.hostname) {
    case 'rpi.squeezetech.com':
      apiUrl = 'https://rpi-api.squeezetech.com/';
      break;
    case 'rapid.contactrpi.com':
      apiUrl = 'https://rapid-api.contactrpi.com/';
      break;
    case 'eoi.nxtins.com':
    case 'nxtins.contactrpi.com':
      apiUrl = 'https://npx-api.contactrpi.com/';
      break;
    default:
      //apiUrl = 'http://rpi-api.localhost:9000/';
      break;
  }
  
  let axiosInstance = null;
  if (authData !== null) {
    axiosInstance = axios.create({
      baseURL: apiUrl,
      headers: { Authorization: "Bearer " + JSON.parse(authData).token },
    });
  } else {
    axiosInstance = axios.create({
      baseURL: apiUrl,
    });
  }
  axiosInstance.interceptors.response.use(
      (response) => {
        return response;
      },
      function (error) {
        // Do something with response error
        if (error.response.status === 401) {
          const auth = localStorage.getItem("auth");
          if (auth !== null) {
            window.location.href = "/logout";
          }
        }
        return Promise.reject(error);
      }
  );
  
  return axiosInstance;
};

export default instance;
